import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Join.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import apiManager from './../../ApiManager';
const Join = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [page, set_page] = useState(1);
    useEffect(() => {
        setInProp(true);
        document.title = "加入活動";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Join"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        {page === 1 &&
                            <YStyled.Col align="flex-start" gap="1.2rem" style={{ boxSizing: "border-box", padding: "1rem" }}>
                                <YStyled.Span size={15} fontWeight={700} style={{ alignSelf: "center" }}>向團主申請加入</YStyled.Span>
                                <YStyled.Span size={17} fontWeight={700} color="#3149CE" style={{ alignSelf: "center" }}>{`${arg.eventVo.events_name}`}</YStyled.Span>
                                <YStyled.Span size={15} fontWeight={700} color="#3149CE">留言給團主：</YStyled.Span>
                                <YStyled.Row contentEditable id="msgEl"
                                    style={{
                                        background: "white", width: "100%", height: "6rem",
                                        borderRadius: "1rem", padding: "1rem", whiteSpace: "pre-wrap", textAlign: "left"
                                    }} dangerouslySetInnerHTML={{ __html: `Hi~ 你主辦的 ${arg.eventVo.events_name} 看起來超讚的！\n\n能讓我加入嗎？`}}>
                                    
                                </YStyled.Row>
                                <YStyled.BTN3 normalBg="#3149CE" normalColor="#ffffff" style={{ marginTop: "1rem", borderRadius: "0.5rem", width: "100%", height: "2rem", borderWidth: "0px" }} onClick={e => {
                                    apiManager.fetchPost(`event/${arg.eventVo.events_id}/join`, {
                                        "event_participants_request_message": document.querySelector("#msgEl").innerText
                                    }).then(res => {
                                        console.log(res);
                                        /* updateParticipants();
                                        updateEvent(); */
                                        set_page(2);
                                    }).catch(err => {
                                        err.json().then(res=>{
                                            console.log(res)
                                            alert(res.message);
                                        })
                                    })
                                }}>
                                    <YStyled.Span size={15}>送出</YStyled.Span>
                                </YStyled.BTN3>
                            </YStyled.Col>
                        }
                        {page === 2 &&
                            <div className={styleUi.page2}>
                                <div className={styleUi.pannel}>
                                    <img src="../assets/ui/mail.png" />
                                    <YStyled.Span color="#3149CE" size={17} fontWeight={700}>已送出</YStyled.Span>
                                    <YStyled.BTN3 normalBg="#3149CE" normalColor="#ffffff" style={{ marginTop: "1rem", borderRadius: "0.5rem", width: "100%", height: "2rem", borderWidth: "0px" }} onClick={e => {
                                        arg.cb();
                                        setInProp(false);
                                    }}>
                                        <YStyled.Span size={15}>OK</YStyled.Span>
                                    </YStyled.BTN3>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Join);